module.exports = __webpack_public_path__ + "img/fi-pp-mepco-package.dbe953aa.png";